import { Location } from "react-router";
import React from "react";
import ReportConstants from "../../constants/ReportConstants";
import { ReportDataDTO, Reports } from "../../types/Reports";
import CloseCutoffReport from "./closeCutoff/CloseCutoffReport";
import TicketRequestFinanceReport from "./finance/TicketRequestFinanceReport";
import ProjectRequestsReport from "./projectRequests/ProjectRequestsReport";
import ReconciliationReport from "./reconciliation/ReconciliationReport";
import RequestsByVenueReport from "./requestsByVenue/RequestsByVenueReport";
import SeasonTicketsReport from "./seasonTickets/SeasonTicketsReport";
import TodaysTicketsReport from "./todaysTickets/TodaysTicketsReport";
import UserRequestsReport from "./userRequests/UserRequestsReport";
import PurchaseOppFinanceReport from "./finance/PurchaseOppFinanceReport";
import RequestCountsReport from "./requestCounts/RequestCountsReport";
import CreditCardReport from "./creditCard/CreditCardReport";

export type ReportHandlerTypeProps = {
  reportData: ReportDataDTO;
  setReportData: (value: React.SetStateAction<ReportDataDTO>) => void;
  setCanExport: (value: boolean) => void;
  location: Location;
};

type ReportHandlerProps = ReportHandlerTypeProps & {
  report: Reports;
};

const ReportHandler = ({ report, reportData, setReportData, setCanExport, location }: ReportHandlerProps) => {
  switch (report.reportId) {
    case ReportConstants.USER_REQUESTS_REPORT_ID:
      return (
        <UserRequestsReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.PROJECT_REQUESTS_REPORT_ID:
      return (
        <ProjectRequestsReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.RECONCILIATION_REPORT_ID:
      return (
        <ReconciliationReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.TICKET_REQUEST_FINANCE_REPORT_ID:
      return (
        <TicketRequestFinanceReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.SEASON_TICKETS:
      return (
        <SeasonTicketsReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.REQUESTS_BY_VENUE:
      return (
        <RequestsByVenueReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.CLOSE_CUTOFF:
      return (
        <CloseCutoffReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.TODAYS_TICKETS:
      return (
        <TodaysTicketsReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.PURCHASE_OPP_FINANCE_REPORT_ID:
      return (
        <PurchaseOppFinanceReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.REQUEST_COUNTS_REPORT_ID:
      return (
        <RequestCountsReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    case ReportConstants.CREDIT_CARD_REPORT_ID:
      return (
        <CreditCardReport
          reportData={reportData}
          setReportData={setReportData}
          location={location}
          setCanExport={setCanExport}
        />
      );
    default:
      return null;
  }
};

export default ReportHandler;
